import script from "./AdCarousel.vue?vue&type=script&setup=true&lang=js"
export * from "./AdCarousel.vue?vue&type=script&setup=true&lang=js"

import "./AdCarousel.vue?vue&type=style&index=0&id=0a48521f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a48521f"]])

export default __exports__